import { usePortalQuery } from 'src/Libs/api'
import { fetchQntmByInstallation } from 'src/Libs/installation-details/api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { QntmModel } from 'src/Libs/installation-details/models'

export const qntmStorageListQueryKey = (installationId: string, deviceLinkId: number): readonly [string, string, number] =>
  ['qntmStorageList', installationId, deviceLinkId] as const

export const useQntmStorageList = (
  installationId: string,
  deviceLinkId: number
): { data: QntmModel[] | undefined; isLoading: boolean; isError: boolean } => {
  const authFetch = useAuthFetchWithResponse()
  const shouldFetch = Boolean(installationId) && deviceLinkId > 0

  const { data, isLoading, isError } = usePortalQuery<QntmModel[]>({
    queryKey: qntmStorageListQueryKey(installationId, deviceLinkId),
    queryFn: () => fetchQntmByInstallation(installationId, deviceLinkId, authFetch),
    enabled: shouldFetch,
    staleTime: 0,
  })

  return { data: data ?? undefined, isLoading, isError }
}
